import { render } from "./events.vue?vue&type=template&id=1a0448a2&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import "./events.vue?vue&type=style&index=0&id=1a0448a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a0448a2"

export default script